import { DialogComponent } from '@theme/dialog';

/**
 * A custom element that manages a cart drawer.
 *
 * Auto-open after an add lives in gobeautex-scripts.liquid (an inline listener
 * registered during parse), not here: a listener attached in connectedCallback
 * only exists once this deferred module upgrades the element, so a fast add —
 * typically from a product card — could fire "cart:update" before it was
 * attached and the drawer would silently fail to open.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
